const carouselItems = [
  {
    title: '暑期限定 · 大片连映',
    desc: '《流浪地球3》《封神第二部》《哪吒之魔童闹海》等年度巨制轮番上阵，高清画质免费看。',
    tag: '限时专题',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20space%20battle%20scene%20with%20massive%20spacecraft%20and%20explosions%2C%20dramatic%20orange%20and%20dark%20blue%20lighting%2C%20blockbuster%20movie%20atmosphere%2C%20professional%20VFX%20style%2C%20grand%20scale%20composition&width=800&height=450&seq=carousel-01&orientation=landscape',
  },
  {
    title: '经典港片 · 永恒回忆',
    desc: '周星驰喜剧、成龙动作、王家卫文艺，91在线视频港片专区带你重温黄金时代的港味经典。',
    tag: '怀旧专题',
    imageUrl: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20street%20scene%20at%20night%20with%20colorful%20neon%20signs%20and%20busy%20market%2C%20classic%20cinema%20nostalgia%2C%20warm%20neon%20glow%2C%20retro%20film%20aesthetic%2C%20atmospheric%20urban%20photography&width=800&height=450&seq=carousel-02&orientation=landscape',
  },
  {
    title: '国漫崛起 · 不容错过',
    desc: '从《灵笼》到《时光代理人》，从《雾山五行》到《深海》，国产动漫精品全集一站式观看。',
    tag: '动漫专题',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20art%20style%20with%20ink%20wash%20painting%20and%20modern%20CGI%20fusion%2C%20fantasy%20landscape%20with%20floating%20mountains%20and%20mist%2C%20artistic%20composition%2C%20warm%20golden%20and%20jade%20green%20tones&width=800&height=450&seq=carousel-03&orientation=landscape',
  },
  {
    title: '悬疑剧场 · 烧脑季',
    desc: '《隐秘的角落》《沉默的真相》《漫长的季节》等高分悬疑剧集一次看过瘾，每部都让你欲罢不能。',
    tag: '悬疑专题',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20foggy%20alley%20at%20night%20with%20single%20streetlamp%2C%20film%20noir%20atmosphere%2C%20dark%20and%20moody%20lighting%2C%20thriller%20movie%20aesthetic%2C%20professional%20cinematic%20photography%20with%20deep%20shadows&width=800&height=450&seq=carousel-04&orientation=landscape',
  },
  {
    title: '综艺娱乐 · 欢乐不断',
    desc: '《奔跑吧》《向往的生活》《乘风破浪》等王牌综艺高清完整版，周末放松的最佳选择。',
    tag: '综艺专题',
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20variety%20show%20stage%20with%20colorful%20lighting%20and%20confetti%2C%20entertainment%20production%20set%2C%20vibrant%20and%20energetic%20atmosphere%2C%20professional%20studio%20photography%2C%20bright%20stage%20lights%20on%20dark%20background&width=800&height=450&seq=carousel-05&orientation=landscape',
  },
  {
    title: '纪录片 · 看见世界',
    desc: 'BBC Earth、国家地理等顶级纪录片品牌精选，从自然奇观到人文历史，足不出户探索地球。',
    tag: '纪录专题',
    imageUrl: 'https://readdy.ai/api/search-image?query=Aerial%20view%20of%20vast%20savanna%20with%20wildlife%20at%20golden%20hour%2C%20documentary%20film%20aesthetic%2C%20warm%20sunset%20light%20on%20African%20plains%2C%20professional%20nature%20photography%2C%20cinematic%20composition&width=800&height=450&seq=carousel-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 mb-4">
            <span className="text-xs text-primary-400 whitespace-nowrap">专题策划</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-50 mb-3">焦点专题</h2>
          <p className="text-sm text-foreground-400 max-w-xl mx-auto">
            精心策划的影视专题合集，带你深度探索西瓜视频免费与91在线视频的精彩世界
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item) => (
            <div key={item.title} className="group bg-background-200/60 rounded-xl overflow-hidden hover:bg-background-200 transition-colors cursor-pointer flex flex-col">
              <div className="aspect-[16/9] bg-background-300 overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <span className="inline-block px-2 py-0.5 rounded text-[10px] font-medium bg-primary-500/20 text-primary-400 mb-2 whitespace-nowrap self-start">
                  {item.tag}
                </span>
                <h3 className="text-base font-medium text-foreground-200 mb-2 group-hover:text-accent-400 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed flex-1">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}